<div
  class="input-group"
  [ngClass]="props.inputClass"
  [class.is-invalid]="showError"
  [class.disabled]="formControl.disabled"
  >
  @if (props.addonStart) {
    <span
      class="input-group-text"
      [ngClass]="props.addonStartClass"
      >
      {{ props.addonStart }}
    </span>
  }

  <input
    type="text"
    class="form-control"
    maxlength="11"
    mask="separator.0"
    thousandSeparator=","
    [formControl]="$any(formControl)"
    [placeholder]="props.placeholder"
    [formlyAttributes]="field"
    [attr.data-testid]="props.testId"
    />

  @if (props.addonEnd) {
    <span
      class="input-group-text"
      [ngClass]="props.addonEndClass"
      >
      {{ props.addonEnd }}
    </span>
  }
</div>
